import { Table, SortableTableHeader } from "soprasteria-ui-library";
import * as React from "react";
import { IClinicListItem } from "../../../../../models/IClinic";
import { useHistory } from "react-router-dom";
import { CLINIC } from "../../../../../utils/RouteConstants";

interface IProps {
    clinics: IClinicListItem[];
}

export const ClinicTable: React.FC<IProps> = ({ clinics }) => {
    const history = useHistory();

    const handleRowClick = (organisationClinicId: number) => {
        history.push(`/${CLINIC}/${organisationClinicId}`);
    }

    return (
        <>
            <section>
                <Table hoverableRows>
                    <thead>
                        <tr>
                            <SortableTableHeader propertyToSortBy="ClinicNumber" headerText="Mottagningsnummer" />
                            <SortableTableHeader propertyToSortBy="Name" headerText="Namn" />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            clinics && clinics.length > 0
                                ? clinics.map((clinic, key) => {
                                    return (
                                        <tr key={key} className="clickable-row" onClick={() => handleRowClick(clinic.clinicId)}>
                                            <td>{clinic.clinicNumber}</td>
                                            <td>{clinic.name}</td>
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan={4}>Det finns inga mottagningar på denna vårdgivare</td></tr>
                        }
                    </tbody>
                </Table>
            </section>
        </>
    )
}